import { getReferralMedication } from 'App/services/RMSService';
import { useQuery } from 'react-query';
import * as R from 'ramda';
import hasLength from 'App/utils/hasLength';

function useGetReferralMedication(patientId, referralId) {
    return useQuery(
        ['patient', patientId, 'referral', referralId, 'medication'],
        () =>
            getReferralMedication(patientId, referralId)
                // prettier-ignore
                .then(
                    R.map(
                        R.over(
                            R.lensProp('statusDate'),
                            R.cond([
                                [
                                    R.is(String),
                                    // prettier-ignore
                                    R.ifElse(
                                        R.compose(hasLength, R.match(/0000-00-00/)),
                                        R.always(null),
                                        R.identity
                                    ),
                                ],
                                [R.T, R.identity],
                            ])
                        )
                    )
                ),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useGetReferralMedication;
